export default __webpack_public_path__ + "static/media/sendBack-white.ba6939e3.png";